import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';

import { ErrorService } from '../../services/error/error.service';
import { LocalStorageService } from '../../services/local-storage.service';
import { ChangePasswordService } from '../../change-password/change-password.service';
import { ResetPasswordData, ResetPasswordResponse } from '../../change-password/change-password.domain';
import { SubmitService } from '../../services/submit.service';
import { Router } from '@angular/router';
import { CommunicationService } from '../../services/communication.service';
import { ValidationsService } from 'src/app/services/validations.service';

@Component({
  providers: [ChangePasswordService],
  selector: 'app-change-password-dialog',
  styleUrls: ['./change-password.component.scss'],
  templateUrl: './change-password.component.html',
})
export class ChangePasswordDialogComponent implements OnInit, OnChanges {
  @Input() email: string = '';
  @Output() changeView: EventEmitter<{ id: number; email?: string }>;

  changePasswordForm: FormGroup;
  disableSubmitButton: boolean;
  errorMessage: string;
  successMessage: string;
  userEmail: string;
  isLoading: boolean;
  showPasswordOne: boolean;
  showPasswordTwo: boolean;
  showPasswordThree: boolean;

  constructor(
    private changePasswordService: ChangePasswordService,
    private errorService: ErrorService,
    private localStorageService: LocalStorageService,
    private messageService: MessageService,
    private submitService: SubmitService,
    private router: Router,
    private communicationService: CommunicationService
  ) {
    this.changeView = new EventEmitter<{ id: number; email: string }>();
  }

  ngOnInit(): void {
    this.disableSubmitButton = true;
    this.userEmail = '';
    this.isLoading = false;
    this.showPasswordOne = false;
    this.showPasswordTwo = false;
    this.showPasswordThree = false;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.email) {
      this.userEmail = changes.email.currentValue || '';
      this.prepareForm();
    }
  }

  saveFormData(): void {
    if (this.changePasswordForm.valid) {
      const requestData: ResetPasswordData = {
        registration: [
          {
            email: this.changePasswordForm.value.email,
          },
          {
            password: this.changePasswordForm.value.oldPassword,
          },
          {
            new_password: this.changePasswordForm.value.newPassword,
          },
        ],
      };

      const subscription = this.changePasswordService.updatePassword(requestData);
      this.isLoading = true;
      subscription.subscribe(
        (response: ResetPasswordResponse) => {
          this.isLoading = false;
          this.errorService.throwErrorIfFailure(response, true, this.errorHandler);
          if (response && response.result === 'success') {
            this.changeView.emit({ id: 0, email: this.changePasswordForm.value.email });
          }
        },
        error => {
          this.isLoading = false;
          if (error.status === 422) {
            this.errorMessage = error.error.message;
          } else {
            this.errorMessage = 'app.user-form.login-failed';
          }
        }
      );
    }
  }

  resetForm(): void {
    this.changePasswordForm.reset();
    this.changePasswordForm.controls.email.setValue(this.userEmail);
    this.changePasswordForm.controls.email.setValidators([Validators.required, ValidationsService.emailValidator()]);
    this.disableSubmitButton = true;
  }

  errorHandler = (): void => {
    this.errorMessage = 'something went wrong';
  };

  prepareForm(): void {
    this.changePasswordForm = new FormGroup({
      email: new FormControl(this.userEmail, [Validators.required, ValidationsService.emailValidator()]),
      oldPassword: new FormControl('', [Validators.required]),
      newPassword: new FormControl('', [Validators.required]),
      repeatPassword: new FormControl('', [Validators.required]),
    });

    this.changePasswordForm.valueChanges.subscribe(values => {
      this.errorMessage = '';
      this.successMessage = '';
      if (this.changePasswordForm.valid) {
        this.disableSubmitButton = values.newPassword !== values.repeatPassword;
      } else {
        this.disableSubmitButton = true;
      }
    });
  }

  closeDialog() {
    this.communicationService.dashboardLogoClick(false);
  }
}
